import {css} from '@logistics-frontend/blocks/theme/css'
import {theme} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  button: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 56px;
    box-sizing: border-box;
    margin-top: ${theme.spacing(2)}px;
    padding: ${theme.spacing(1.5, 2)};
    cursor: pointer;
    border-radius: ${theme.spacing(2)}px;
    background-color: #f5f4f2;
  `,
  placeholder: css`
    color: #9e9b98;
  `,
  placeholderTop: css`
    font-size: 13px;
  `,
  fixedWidth: css`
    width: 360px;
  `,
}
